var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51823 3.5181C5.17618 1.86018 7.46898 0.833252 10 0.833252C12.5311 0.833252 14.8239 1.86018 16.4818 3.5181L15.8926 4.10736L16.4818 3.51811C18.1398 5.17605 19.1667 7.46886 19.1667 9.99992C19.1667 12.531 18.1398 14.8238 16.4818 16.4817C14.8239 18.1396 12.5311 19.1666 10 19.1666C7.46898 19.1666 5.17617 18.1396 3.51823 16.4817L4.10748 15.8925L3.51822 16.4817C1.8603 14.8238 0.833374 12.531 0.833374 9.99992C0.833374 7.46886 1.8603 5.17605 3.51822 3.51811L3.51823 3.5181ZM14.756 8.08917C15.0814 7.76374 15.0814 7.2361 14.756 6.91066C14.4305 6.58523 13.9029 6.58523 13.5775 6.91066L9.16671 11.3214L7.25596 9.41066C6.93053 9.08523 6.40289 9.08523 6.07745 9.41066C5.75201 9.7361 5.75201 10.2637 6.07745 10.5892L8.57745 13.0892C8.90289 13.4146 9.43053 13.4146 9.75596 13.0892L14.756 8.08917Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.d5d5816574a968c76cf5fa88ef3fe262.svg";
export { ForwardRef as ReactComponent };